module.exports = __webpack_public_path__ + "static/img/section6_content1_bg1.b5278a30.png";